import Joi from "joi-browser";

const validationSchema = {
  name: Joi.string()
    .label("Nombre")
    .trim()
    .max(255)
    .required(),
  agency: Joi.string()
    .label("Agencia/Manager")
    .allow([null, ""])
    .optional(),
  lastname: Joi.string()
    .label("Apellido")
    .trim()
    .max(255)
    .required(),
  birthday: Joi.object()
    .label("Fecha de nacimiento")
    .required(),
  email: Joi.string()
    .label("Correo electrónico")
    .email()
    .insensitive()
    .required(),
  password: Joi.string()
    .label("Contraseña")
    .trim()
    .min(6)
    .required(),
  residence: Joi.string()
    .label("País de residencia")
    .required(),
  nationality: Joi.string()
    .label("Nacionalidad")
    .required(),
  biography: Joi.string()
    .label("Reseña CV")
    .regex(/^\W*(?:\w+\b\W*){0,110}$/)
    .required()
    .error(() => ({
      type: "string.regex",
      message: "Máximo 110 palabras"
    })),
  images: Joi.array()
    .label("Imágenes")
    .max(8)
    .min(1)
    .error(() => ({
      type: "array.min",
      message: "Debes subir al menos una imagen"
    })),
  ToS: Joi.boolean().valid(true)
};

export default validationSchema;



// WEBPACK FOOTER //
// ./src/containers/General/RegisterPage/validation.js